<template>
  <div class="aui-nav-heading">
    <strong>{{name}}</strong>
  </div>
</template>

<script>
  export default {
    props: {
      name: String
    }
  }
</script>
